import { useTranslation } from 'react-i18next';
import { SubscriptionCheckout } from '../../Billing/SubscriptionCheckout';
import Button from 'components/Buttons/Button';
import { Cart } from 'containers/Billing/types';
import { Plan } from 'types/plan';

interface Props {
  cart: Cart;
  setCart: (cart: Cart) => void;
  subscribablePlans: Plan[];
  isCheckoutDisabled: boolean;
  isLoading: boolean;
  isCheckoutLoading: boolean;
  onCheckout: () => Promise<void>;
}

export function UserAddLicences({
  cart,
  setCart,
  subscribablePlans,
  isCheckoutDisabled,
  isCheckoutLoading,
  onCheckout,
}: Props) {
  const { t } = useTranslation(['userSettings']);
  return (
    <SubscriptionCheckout
      plansTitle={t('userSettings:schoolSubscription.addLicenses')}
      cart={cart}
      onCartChange={setCart}
      plans={subscribablePlans}
      controls={
        <div tw="flex flex-col gap-2 mt-4">
          <Button
            intent="primary"
            disabled={isCheckoutDisabled}
            fill
            loading={isCheckoutLoading}
            onClick={onCheckout}
          >
            {t('userSettings:schoolSubscription.goToPayment')}
          </Button>
        </div>
      }
    />
  );
}
